import React from 'react';
import { TablePagination } from '@mui/base';
import './pagination.css';
import { Dropdown } from '..';
import PaginationAction from './pagination-action';
import { NAMESPACE, useLang } from '@/hooks/use-lang';

interface IProps {
  total: number;
  currentPage?: number;
  pageSize?: number;
  pageSizeOptions?: number[];
  onPageSizeChange?: (size: number) => void;
  onPageChange?: (page: number) => void;
  showSizeChanger?: boolean;
}

export function Pagination(props: IProps) {
  const { t } = useLang(NAMESPACE.common);
  const {
    currentPage,
    total = 0,
    pageSize = 15,
    onPageSizeChange,
    pageSizeOptions = [5, 10, 15, 20],
    onPageChange,
    showSizeChanger = false,
  } = props;
  const [localPage, setLocalPage] = React.useState(1);
  const [localPageSize, setLocalPageSize] = React.useState(10);

  React.useEffect(() => {
    currentPage && setLocalPage(currentPage);
  }, [currentPage]);

  React.useEffect(() => {
    pageSize && setLocalPageSize(pageSize);
  }, [pageSize]);

  const changePage = (page) => {
    !currentPage && setLocalPage(page);
    onPageChange && onPageChange(page);
  };

  const changePageSize = (sizeValue) => {
    if (!props.hasOwnProperty('pageSize')) {
      setLocalPageSize(sizeValue);
    }
    onPageSizeChange && onPageSizeChange(sizeValue);
    setLocalPage(1);
  };

  const dropDown = () => {
    const localPageSizeOptions = Array.isArray(pageSizeOptions) ? pageSizeOptions : [];
    return (
      <Dropdown
        options={localPageSizeOptions?.map((size) => ({
          label: size,
          value: size,
        }))}
        onSelect={(value) => changePageSize(value)}
        value={localPageSize}
      />
    );
  };

  return (
    <TablePagination
      onPageChange={changePage}
      labelRowsPerPage={t('results.per.page')}
      count={total}
      rowsPerPage={pageSize}
      page={total > 0 ? localPage : 0}
      labelDisplayedRows={() => {
        return showSizeChanger && total > 0 ? t('of') + ` ${total}` : '';
      }}
      slots={{
        root: 'div',
        select: showSizeChanger && total > 0 ? dropDown : () => <div />,
        selectLabel: showSizeChanger && total > 0 ? 'p' : () => <div />,
        actions: (actionProps) => {
          return (
            <>
              {total > 0 && (
                <PaginationAction
                  currentPage={actionProps.page}
                  total={actionProps.count}
                  rowsPerPage={localPageSize}
                  onChange={actionProps.onPageChange}
                />
              )}
            </>
          );
        },
      }}
      slotProps={{
        toolbar: { className: 'c-pagination-toolbar sm:flex sm:flex-wrap sm:gap-y-4' },
        displayedRows: { className: 'c-pagination-total-label' },
      }}
    />
  );
}
